import React, { useContext } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import FormContext from "./FormContext";

const FormLabel = ({ htmlFor, srOnly, className, ...props }) => {
  const { controlId } = useContext(FormContext);
  const classes = classNames("form-label", className, srOnly && "sr-only");

  return (
    <label {...props} className={classes} htmlFor={htmlFor || controlId} />
  );
};

FormLabel.propTypes = {
  htmlFor: PropTypes.string,
  className: PropTypes.string
};

export default FormLabel;
